export default {
    name: "TranslateHelpers",
    methods: {
        translateString(string)
        {
            return this.__(string);
        },
        getOptions(options)
        {
            let option_array = [];

            options.forEach(option =>
            {
                option_array.push(this.__(option));
            })

            return option_array;
        }
    },
};
